<template>
<div class="checked">
  <DetailsItem v-bind="getProps"/>
  <div class="checked-box">
    <div v-for="item of options" :key="item.id" class="checked-box-item">
      <img class="img" v-lazy="`${item.imageURL}?x-oss-process=image/resize,m_fill,w_240,h_240`" alt="">
      <div class="content" @click="checkedItem(item)">
        <span class="desc">{{item.content}}</span>
        <CheckBox v-if="Object.is(topicType, 1)"  v-model="item.checked"/>
        <Radio v-else v-model="radioId" :id="item.id"/>
      </div>
    </div>
  </div>
  <button @click="vote" :class="{ grey: getChecked.length === 0 }">投票</button>
  <div class="tip" @click="changeError" v-if="showError">
    <span>至少也得选一个呀</span>
  </div>
</div>
</template>
<script>
import DetailsItem from './topicDetailItem'
import CheckBox from './checkbox'
import Radio from './radio'
import { get, post } from '../../../utils/request'
import { get as getUser } from '../../../utils/token'
export default {
  components: {
    DetailsItem,
    CheckBox,
    Radio
  },
  data () {
    return {
      showError: false,
      id: '',
      imageURL: '',
      subTitle: '',
      title: '',
      topicType: 0,
      options: [],
      values: [],
      preCount: 0,
      radioId: 0
    }
  },
  mounted () {
    this.getTopicDetails()
  },
  methods: {
    checkedItem (item) {
      if (Object.is(this.topicType, 1)) {
        item.checked = !item.checked
      } else {
        if (this.radioId === item.id) {
          this.radioId = 0
        } else {
          this.radioId = item.id
        }
      }
    },
    changeError () {
      this.showError = !this.showError
    },
    getTopicDetails () {
      const user = getUser('user')
      const { id } = this.$route.params
      const promise = get({
        url: `/topic/h5TopicDetail/${id}/${user.id}`
      })
      promise.then(res => {
        const { data: { code, detail } } = res
        if (Object.is(code, 200)) {
          const { imageURL, options, preCount, subTitle, title, topicType } = detail
          this.imageURL = imageURL
          this.options = options.map(item => {
            item.checked = false
            return item
          })
          this.preCount = preCount
          this.subTitle = subTitle
          this.title = title
          this.topicType = topicType
        }
      })
    },
    vote () {
      if (this.getChecked.length === 0) {
        this.changeError()
        setTimeout(() => {
          this.changeError()
        }, 1000)
        return
      }
      const user = getUser('user')
      const { id } = this.$route.params
      const promise = post({
        url: `/topic/h5TopicDetail/${id}/${user.id}`,
        data: {
          selectionList: this.getChecked
        }
      })
      promise.then(res => {
        const { data: { code } } = res
        if (Object.is(code, 200)) {
          this.$router.push({
            path: `/exerland/topicDetails/${id}`
          })
        }
      })
    }
  },
  computed: {
    getProps () {
      return {
        imageURL: this.imageURL,
        preCount: this.preCount,
        subTitle: this.subTitle,
        title: this.title
      }
    },
    getChecked () {
      if (Object.is(this.topicType, 1)) {
        return this.options.filter(item => item.checked).map(item => item.id)
      } else {
        return [this.radioId]
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.checked {
  height: 100vh;
  overflow-y: scroll;
  .tip {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      background:rgba(0,0,0,0.8);
      border-radius:6px;
      font-size:14px;
      font-family:AlibabaPuHuiTi-Regular,AlibabaPuHuiTi;
      font-weight:400;
      color:rgba(255,255,255,1);
      line-height:20px;
      display: block;
      padding: 10px 18px;
    }
  }
  .checked-box {
  padding: 25px 16px 32px;
  .checked-box-item {
    width: 100%;
    height: 72px;
    margin-bottom: 16px;
    display: flex;
    .img {
      width:72px;
      height:72px;
    }
    .content {
      width: calc(100% - 72px);
      display: flex;
      justify-content:space-between;
      align-items: center;
      height:72px;
      background:rgba(245,245,245,1);
      box-sizing: border-box;
      padding: 16px;
      .desc {
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:20px;
        max-width: calc(100% - 40px);
      }
    }
  }
}
button {
  width: calc(100% - 32px);
  margin: 0 16px;
  background:rgba(24,204,159,1);
  height:44px;
  font-size:20px;
  font-family:AlibabaPuHuiTi-Medium,AlibabaPuHuiTi;
  font-weight:500;
  color:rgba(255,255,255,1);
  line-height:27px;
  border: none;
  margin-bottom: 40px;
  outline: none;
}
.grey{
  background:rgba(204,204,204,1);
}
}
</style>
